// extracted by mini-css-extract-plugin
export default {"badge":"SlackToggle_badge__FMjOQ","toggle":"SlackToggle_toggle__iaRLU","track":"SlackToggle_track__23NYL","thumb":"SlackToggle_thumb__tZJvx"};